import styled from '@emotion/styled';
import { Box, Button, Dropdown, Text } from '@opendoor/bricks-next';

import { CityNearMeButton } from './NearMeButton';

const DropdownWrapper = styled.div`
  min-width: 150px;
  > div {
    gap: 0 !important;
  }
  label {
    display: none !important;
  }
`;

interface DirectoryHeaderProps {
  pageType: 'city' | 'state';
  locationName: string;
  locationSlug: string;
  totalCount: number;
  stateName?: string | null;
  displayingCity?: string | null;
  availableCities?: Array<{ name: string; slug: string }> | null;
  nearMeCity?: string | null;
  nearMeCityCount?: number | null;
  marketSlug?: string;
}

export const DirectoryHeader: React.FC<DirectoryHeaderProps> = ({
  pageType,
  locationName,
  locationSlug,
  totalCount,
  stateName,
  displayingCity,
  availableCities,
  nearMeCity,
  nearMeCityCount,
  marketSlug,
}) => {
  const hasMultipleCities = availableCities && availableCities.length > 1;

  const StateHeader = () => (
    <>
      <Text tag="h1" typography="$headerLarge" mb="$2x" textAlign="center">
        Homes for Sale in {locationName}
      </Text>

      {displayingCity && (
        <Text tag="h2" typography="$headerSmall" mb="$4x" textAlign="center">
          Top properties in {displayingCity}
        </Text>
      )}
    </>
  );

  const CityHeader = () => (
    <Text tag="h1" typography="$headerLarge" mb="$4x" textAlign="center">
      {totalCount} {totalCount === 1 ? 'Home' : 'Homes'} for Sale in {locationName}
      {stateName && `, ${stateName}`}
    </Text>
  );

  return (
    <Box
      mb="$2x"
      pb="$2x"
      style={{ position: 'sticky' }}
      top={0}
      backgroundColor="$backgroundPrimary"
      zIndex={1}
    >
      {pageType === 'state' ? <StateHeader /> : <CityHeader />}
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="center"
        alignItems="center"
        mb="$2x"
        gap="$8x"
        $smallerThanLG={{
          gap: '$4x',
        }}
        $smallerThanMD={{
          flexDirection: hasMultipleCities ? 'column' : 'row',
        }}
      >
        <CityNearMeButton city={nearMeCity} count={nearMeCityCount} />
        {hasMultipleCities && (
          <DropdownWrapper>
            <Dropdown
              title="Top homes in"
              size="medium"
              options={availableCities.map((city) => ({
                label: city.name,
                value: city.slug,
              }))}
              prefilledValue={marketSlug}
              onValueChange={(citySlug) => {
                window.location.href = `/homes/state/${locationSlug}?city=${citySlug}`;
              }}
            />
          </DropdownWrapper>
        )}
        <Button
          analyticsName="see-map-link"
          href={`/homes/${marketSlug}`}
          variant="primary"
          size="medium"
          label="View Map"
        />
      </Box>
    </Box>
  );
};
